import { render, staticRenderFns } from "./DialogUpdateDelivery.vue?vue&type=template&id=6901dd8b&scoped=true"
import script from "./DialogUpdateDelivery.vue?vue&type=script&lang=js"
export * from "./DialogUpdateDelivery.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6901dd8b",
  null
  
)

export default component.exports